import useDefinedContext from "hooks/useDefinedContext";
import OrganisationContext from "../";

function useOrganisation() {
  return useDefinedContext(OrganisationContext);
}

export default useOrganisation;
